import { render } from "./LimpiarPantallaModal.vue?vue&type=template&id=1151e11f&scoped=true"
import script from "./LimpiarPantallaModal.vue?vue&type=script&lang=js"
export * from "./LimpiarPantallaModal.vue?vue&type=script&lang=js"

import "./LimpiarPantallaModal.vue?vue&type=style&index=0&id=1151e11f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1151e11f"]])

export default __exports__